// extracted by mini-css-extract-plugin
export var addButton = "_9r-0";
export var border = "_9r-8";
export var check = "_9r-h";
export var danger = "_9r-6";
export var dropdownContainer = "_9r-1";
export var editModalBody = "_9r-j";
export var footerContainer = "_9r-i";
export var fullWidth = "_9r-a";
export var hide = "_9r-9";
export var icon = "_9r-3";
export var input = "_9r-7";
export var inputFlex = "_9r-b";
export var inputWrapper = "_9r-c";
export var manualFocus = "_9r-5";
export var optionButton = "_9r-4";
export var pillWrapper = "_9r-e";
export var pointer = "_9r-2";
export var showOverflow = "_9r-f";
export var tagsFlex = "_9r-d";
export var xButton = "_9r-g";